(function () {
  const CONTAINER_SEL = '#__littleregistry__app-embed-container';
  const SENTINEL_ATTR = 'data-lr-style-injected';
  let done = false;

  const CSS_TEXT = `
    /* Typography for the widget */
    :host, :host *, #widget-button, #registry-box, #registry-box * {
      font-family: "Montserrat", sans-serif;
      font-weight: var(--font-button-font-weight);
      font-size: var(--font-button-text-size);
      text-transform: var(--font-button-case);
      letter-spacing: var(--font-body-letter-spacing);
      line-height: 1.2em;
    }

    /* Remove native border/shadow to avoid "double border" look */
    button {
      margin: 2px;
      position: relative;
      border: none !important;
      box-shadow: none !important;
      border-radius: var(--buttons-radius-outset, 50px) !important;
      isolation: isolate;
      /* keep existing text color; ring uses currentColor */
      /* color: #0454A5; */
    }

    /* Draw a single uniform border ring with ::before */
    button::before {
      content: "";
      position: absolute;
      inset: 0;
      pointer-events: none;
      border-radius: inherit;
      box-shadow: 0 0 0 2px currentColor;   /* 2px ring */
      transition: box-shadow .18s ease;
      z-index: 0;
    }

    /* Hover → +1px thicker ring (3px total) */
    button:hover::before {
      box-shadow: 0 0 0 3px currentColor;
    }

    span {
      padding-left: 4px;
    }
  `;

  function injectCSSIntoShadow(shadowRoot) {
    // Avoid duplicate injection
    if (shadowRoot.host && shadowRoot.host.hasAttribute(SENTINEL_ATTR)) return true;

    try {
      if ('adoptedStyleSheets' in Document.prototype && 'replaceSync' in CSSStyleSheet.prototype) {
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS_TEXT);
        shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, sheet];
      } else {
        const style = document.createElement('style');
        style.textContent = CSS_TEXT;
        shadowRoot.appendChild(style);
      }
      if (shadowRoot.host) shadowRoot.host.setAttribute(SENTINEL_ATTR, '1');
      return true;
    } catch (e) {
      console.warn('Style injection failed:', e);
      return false;
    }
  }

  function findOpenShadowUnder(node) {
    const q = [node];
    while (q.length) {
      const el = q.shift();
      if (el && el.shadowRoot) return el.shadowRoot; // first open shadow root
      if (el && el.children && el.children.length) q.push(...el.children);
    }
    return null;
  }

  const timeouts = [];

  function runOnce() {
    if (done) return;
    const container = document.querySelector(CONTAINER_SEL);
    if (!container) return;

    // If there's an iframe, we can't style its internals (skip and try next tick)
    if (container.querySelector('iframe')) return;

    const root = findOpenShadowUnder(container);
    if (root && injectCSSIntoShadow(root)) {
      done = true;
      // cancel any future scheduled runs
      while (timeouts.length) clearTimeout(timeouts.pop());
      // console.info('Styles injected and retries cancelled.');
    }
  }

  // Schedule tries at 1s, 2s, 3s
  [1000, 2000, 3000].forEach(ms => timeouts.push(setTimeout(runOnce, ms)));
})();
